import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel'

// import $ from 'jquery';

import "bootstrap";
import './styles/style.scss'
import './styles/responsive.scss'


import "./images/slide-img.png";
import "./images/slide-img-2.png";
import "./images/slide-img-3.png";
import "./images/new_launch_1.png";
import "./images/new_launch_2.png";
import "./images/new_launch_3.png";

import "./images/orange.png";
import "./images/grapes.png";
import "./images/gauva.png";
import "./images/client.png";

import "./images/fb.png";
import "./images/twitter.png";
import "./images/linkedin.png";
import "./images/instagram.png";

import { go_to_shop } from './libs/common';
import { setupHeader } from './header';

import {createDiv, createImg, createDOMElement} from './libs/elementFactory';

import { pd_info } from './data/product_information';

var new_launches_wrapper = document.getElementById("new_launches_wrapper");
var contact_us_submit_button = document.getElementById("contact_us_submit_button");

function generate_new_arrival_card(products, new_arrivals) {
    var pcount = 0;
    new_arrivals.forEach(product => {
        
        if (pcount > 2) {
            return;
        }
        
        let pd_details = products[product];
        console.log(product, pd_details);
        let img_url = pd_details["Catalog Image Link"]+"01.jpg";
        let product_title = pd_details["Sku Name"];
        let product_description = pd_details["Product Description"]; 
        let card = createDiv("", ["card"]);
        let img = createImg("", img_url, ["ard-img-top"], [{"key":"alt", "value":"Card image cap"}]);
        card.appendChild(img);
        let card_body = createDiv("", ["card-body"]);
        let card_title = createDOMElement("h5", "", ["card-title"],[]);
        card_title.innerHTML = product_title;
        card_body.appendChild(card_title);
        
        let card_description = createDOMElement("p", "", ["card-text"],[]);
        card_description.innerHTML = product_description;
        card_body.appendChild(card_description);
        
        card.appendChild(card_body);
        
        new_launches_wrapper.appendChild(card);
        pcount = pcount + 1;
    })
}

function generate_top_products_card(products, top_products) {
    top_products.forEach(product => {
        let pd_details = products[product];
        let img_url = pd_details["Catalog Image Link"]+"01.jpg";
        let product_title = pd_details["Sku Name"];
        let product_description = pd_details["Product Description"];

        let row = createDiv("", ["row","layout_padding2"]);
        let pd_details_column = createDiv("", ["col-md-8"]);
        let pd_details_box = createDiv("", ["fruit_detail-box"]);
        let title_heading = createDOMElement("h3");
        title_heading.innerHTML = product_title;
        pd_details_box.appendChild(title_heading);

        let description_p = createDOMElement("p", "", ["mt-4", "mb-5"])
        description_p.innerHTML = product_description;
        pd_details_box.appendChild(description_p);

        let buy_button_wrapper = createDiv();
        let buy_now_button = createDOMElement("a","",["custom_dark-btn"], [{"key":"href","value":""}]);
        buy_now_button.innerHTML = "BUY NOW";
        buy_now_button.href = pd_details["Meesho Link"];
        buy_now_button.setAttribute("rel", "noopener noreferrer");
        buy_now_button.setAttribute("target", "_blank");
        
        buy_button_wrapper.appendChild(buy_now_button);

        pd_details_box.appendChild(buy_button_wrapper);

        pd_details_column.appendChild(pd_details_box);

        let image_box_wrapper = createDiv("",["col-md-4", "d-flex", "justify-content-center", "align-items-center"]);
        let image_box = createDiv("", ["fruit_img-box", "d-flex", "justify-content-center", "align-items-center"]);
        let img = createImg("", img_url, [], [{"key":"width", "value":"250px"}]);
        image_box.appendChild(img);
        image_box_wrapper.appendChild(image_box);

        row.appendChild(pd_details_column);
        row.appendChild(image_box_wrapper);
        document.getElementById("top_products_container").appendChild(row);
    });
}

function load_new_launches_section() {
    let products = pd_info["products"]
    let new_arrivals = pd_info["new_arrivals"];

    console.log(new_arrivals);
    console.log(Object.keys(products).length, new_arrivals.length);
    generate_new_arrival_card(products, new_arrivals);
    products = null;
    new_arrivals = null;
}

function load_top_products_section() {
    let products = pd_info["products"]
    let top_products = pd_info["top_products"];

    generate_top_products_card(products, top_products);

    products = null;
    top_products = null;

}

function setupContactUsSection() {
    contact_us_submit_button.onclick = function () {
        let name = document.getElementById("contact_us_name").value;
        let phone = document.getElementById("contact_us_phone_number").value;
        let email = document.getElementById("contact_us_email").value;
        let message = document.getElementById("contact_us_message").value;

        if (!name || !phone || !message) {
            console.error("Not all required values given.");
            return;
        }

        let message_content = "STUDNSTUN Reachout: Name: "+name+", Phone: "+phone+", Email: "+email+", Message: "+message; 

        let prefilled_link = "https://wa.me/7899665828?text="+encodeURIComponent(message_content.trim())
        window.open(prefilled_link, '_blank').focus();
    }
}

function load_new_arrivals_button() {
    document.getElementById("new_arrivals_button").onclick = function() {
        window.open(meesho_shop_link, '_blank').focus();
    }
}

function load_see_more_button() {
    document.getElementById("see_more_button").onclick = function()  {
        window.open(meesho_shop_link, '_blank').focus()
    }
}

function load_shop_now_button() {
    document.getElementById("shop_now_button_banner").onclick = function() {
        go_to_shop("meesho");
    } 
}

function initUi() {
    setupHeader();
    load_shop_now_button();
    load_new_arrivals_button();
    load_see_more_button();
    load_new_launches_section();
    load_top_products_section();
    setupContactUsSection();
}

window.onload = function() {
    initUi();
}